<template>
  <div id="capture">
    <div v-if="invalidToken" class="columns">
      <div class='column is-6 is-offset-3'>
        <p>&nbsp;</p>
        <div class='column is-horizontal-center top-logo'>
          <figure class='image'>
            <img src="../../../../assets/images/excel-logo-full.png">
          </figure>
        </div>
        <div >
          <div class="password-reset" style="margin-bottom: 25px;">
            <p style="margin-bottom: 10px;"><img src="../../../../assets/images/error.png" /></p>
            <p style="font-size: 16px; font-weight: bold;">Invalid Token</p>
            <br />
            <p style="font-size: 16px;">
              Please use link found in your email.
            </p>
          </div>
        </div>
      </div>

    </div>
    <cliploader v-if="!invalidToken" :loading="showUploadLoader" :size="size" class="upload-file"></cliploader>
    <!-- <div v-else>
      <iframe v-if="showiFrame" ref="pandadocIframe" :src="iframeSrc" class="responsive-iframe"></iframe>
    </div> -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
			size: '50px',
      showUploadLoader: true
    };
  },

  computed: {
    ...mapState("signature", {
      invalidToken: state => state.invalidToken,
      signatureData: state => state.signatureData,
      showiFrame: state => state.showiFrame,
    }),
    iframeSrc() {
      return `https://app.pandadoc.com/s/${this.signatureData.session_id}/`;
    },
  },

  methods: {
    fetchData() {
      // this will save the url of client
      VueStore.dispatch("global/getBaseURL");
    },

    //this will gather url parameters and check for valid token.
    prcoessURL() {
      var url_string = window.location.href;
      var url = new URL(url_string);
      var token = url.searchParams.get("token");
      var id = url.searchParams.get("id");

      if (token !== null && id !== null) {
        var data = {
          token: token,
          id: id
        };

        // delay so auth store is loaded.
        setTimeout(function () {
          VueStore.dispatch("signature/checkToken", data);
        }, 500);
      } else {
        // show invalid token
        VueStore.dispatch("signature/setVariable", {
          key: "pageError",
          value: true
        });
        // show invalid token
        VueStore.dispatch("signature/setVariable", {
          key: "invalidToken",
          value: true
        });
      }
    },

    //if token are valid, it will redirect
    checkRedirect(){
      setTimeout(() => {
        if (!this.invalidToken) {
          const redirectToPandaDoc = `https://app.pandadoc.com/s/${this.signatureData.session_id}/`;
          window.location.href = redirectToPandaDoc;
        }
      }, 2000);
    }
  },

  mounted() {
    this.fetchData();
    this.prcoessURL();
    // retrive environment variables and stored in vuex.
    VueStore.dispatch("auth/setVariables");
    this.checkRedirect();
  }
};
</script>

<style scoped>
.responsive-iframe {
  width: 100%;
  /* Set the iframe width to 100% of its container */
  height: 100vh;
  /* Set the iframe height to 100% of the viewport height */
}
</style>
